import React, { FC } from 'react';
import { Box } from '@mui/material';

interface DishImageProps {
  src: string;
  alt: string;
}

export const DishImage: FC<DishImageProps> = ({ src, alt }) => {
  return (
    <Box width="50%">
      <img
        src={src}
        alt={alt}
        width="100%"
        height="100%"
        style={{ objectFit: 'cover' }}
      />
    </Box>
  );
};

export default DishImage;
